import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react'
import { node } from 'prop-types'
import { getCookieClient } from 'settings/app/helpers'

const LocalisationContext = createContext(null)

const LocalisationProvider = ({ children }) => {
  const [clientID, setClientID] = useState(false)
  const [clientName, setClientName] = useState('')
  const [localized, setLocalized] = useState(false)

  const refGetCookieClient = useCallback(() => getCookieClient(), [])

  useEffect(() => {
    const cookie = getCookieClient()
    if (cookie.clientId && cookie.clientId >= 0) {
      setLocalized(true)
      setClientID(cookie.clientId)
      setClientName(cookie.clientName)
    }
  }, [refGetCookieClient])

  return (
    <LocalisationContext.Provider
      value={{
        clientID,
        clientName,
        localized,
      }}>
      {children}
    </LocalisationContext.Provider>
  )
}

LocalisationProvider.propTypes = {
  /** component stack */
  children: node,
}

const LocalisationConsumer = ({ children }) => (
  <LocalisationConsumer.Consumer>
    {(context) => {
      if (context === undefined) {
        throw new Error(
          'LocalisationConsumer must be used with in a LocalisationProvider'
        )
      }
      return children(context)
    }}
  </LocalisationConsumer.Consumer>
)

const useLocalisation = () => {
  const context = useContext(LocalisationContext)

  if (context === undefined) {
    throw new Error(
      'LocalisationContext must be used within a LocalisationProvider'
    )
  }

  return context
}

export { LocalisationProvider, LocalisationConsumer, useLocalisation }
